import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledText = styled.p<{ hasExtendedMargin?: boolean }>`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["500"],
        $size: 14,
    })};
    line-height: 44px;
    margin: ${({ hasExtendedMargin }) => (hasExtendedMargin ? "0 0 0 32px" : "0 0 0 8px")};
`;

export const StyledItem = styled.div<{ isDisabled: boolean; canBeHovered?: boolean }>`
    align-items: center;
    justify-content: space-between;
    display: flex;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
    padding-left: 16px;
    padding-right: 8px;
    border-radius: 3px;

    ${({ canBeHovered, isDisabled }) => {
        if (canBeHovered) {
            return css`
                cursor: ${isDisabled ? "not-allowed" : "pointer"};

                &:hover {
                    background-color: ${isDisabled ? colorsPalettes.carbon["0"] : colorsPalettes.carbon["25"]};
                }
            `;
        }

        return css`
            cursor: ${isDisabled ? "not-allowed" : "default"};
        `;
    }}
`;

const StyledItemContent = styled(Flex)``;
